import { BrowserRouter, Navigate, Route, Routes, useLocation } from "react-router-dom";
import "@/App.css";
import "@/App.extra.css";
import "@/App.field.css";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import LoginPage from "@/pages/LoginPage";
import AuthCallback from "@/pages/AuthCallback";
import AppLayout from "@/components/AppLayout";
import Home from "@/pages/Home";
import AssessmentsList from "@/pages/AssessmentsList";
import ReportArchive from "@/pages/ReportArchive";
import AssessmentDetail from "@/pages/AssessmentDetail";
import AuditLog from "@/pages/AuditLog";
import PublicReport from "@/pages/PublicReport";
import TurkeyMap from "@/pages/TurkeyMap";
import Analytics from "@/pages/Analytics";
import FieldMode from "@/pages/FieldMode";
import VerifyReport from "@/pages/VerifyReport";

function RouterShell() {
  const location = useLocation();
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  const app = (el) => <ProtectedRoute><AppLayout>{el}</AppLayout></ProtectedRoute>;
  return (
    <Routes>
      <Route path="/login" element={<LoginPage/>}/>
      <Route path="/auth/callback" element={<AuthCallback/>}/>
      <Route path="/home" element={app(<Home/>)}/>
      <Route path="/dashboard" element={<Navigate to="/home" replace/>}/>
      <Route path="/assessments" element={app(<AssessmentsList/>)}/>
      <Route path="/assessments/:id" element={app(<AssessmentDetail/>)}/>
      <Route path="/reports" element={app(<ReportArchive/>)}/>
      <Route path="/audit" element={app(<AuditLog/>)}/>
      <Route path="/map" element={app(<TurkeyMap/>)}/>
      <Route path="/analytics" element={app(<Analytics/>)}/>
      <Route path="/saha/:id" element={app(<FieldMode/>)}/>
      <Route path="/verify/:code" element={<VerifyReport/>}/>
      <Route path="/public/reports/:token" element={<PublicReport/>}/>
      <Route path="*" element={<Navigate to="/home" replace/>}/>
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <RouterShell/>
      </AuthProvider>
    </BrowserRouter>
  );
}
